// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import DoughnutChartController from './doughnut_chart_controller';
application.register('doughnut-chart', DoughnutChartController);

import StateDropdownController from './state_dropdown_controller';
application.register('state-dropdown', StateDropdownController);
